<template>
  <span>{{ formatted }}</span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'DateFlyfood',
  props: {
    value: { type: [String, Number, Date], required: true },
    parseFormat: { type: String, default: null },
    outputFormat: { type: String, default: 'YYYY-MM-DD' }
  },
  computed: {
    formatted() {
      if (this.value == null || this.value === '') return '';
      const m = this.parseFormat ? moment(this.value, this.parseFormat, true) : moment(this.value);
      return m.isValid() ? m.format(this.outputFormat) : '';
    }
  }
}
</script>